import script from "./CombineProductsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CombineProductsModal.vue?vue&type=script&setup=true&lang=ts"

import "./CombineProductsModal.vue?vue&type=style&index=0&id=c5ac8c38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5ac8c38"]])

export default __exports__